import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Link, browserHistory } from 'react-router';
import { FORM_ERROR } from 'final-form';

import { updateSettings2, updated } from '../../actions/auth';
import NavBarConfig from '../../components/NavBarConfig';
import SettingsForm from '../../components/forms/SettingsForm';

const messages = defineMessages({
  PROPERTIES: {
    id: 'SettingsPage.PROPERTIES',
    defaultMessage: 'Einstellungen',
  },
  CHANGE_PASSWORD: {
    id: 'SettingsPage.CHANGE_PASSWORD',
    defaultMessage: 'Passwort ändern',
  },
  PERSONAL_DATA: {
    id: 'SettingsPage.PERSONAL_DATA',
    defaultMessage: 'Hier kannst du deine persönlichen Account-Daten verwalten.',
  },
  SECURITY: {
    id: 'SettingsPage.SECURITY',
    defaultMessage: 'Sicherheit',
  },
  SECURITY_DESC: {
    id: 'SettingsPage.SECURITY_DESC',
    defaultMessage: 'Schütze deinen Account mit einem sicheren Passwort.',
  },
});

function SettingsPage({ user, onSubmit, route, intl: { formatMessage } }) {
  const avatarInitials = user && user.name ? user.name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase() : 'U';
  
  return (
    <div style={{ backgroundColor: 'transparent', minHeight: '100vh', width: '100%', padding: '16px' }}>
      <NavBarConfig currentRouteName={route.name} />
      
      <div style={{ maxWidth: '1400px', margin: '0 auto' }}>
        <div style={{ maxWidth: '600px' }}>
          {/* Header */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
            <button 
              onClick={() => browserHistory.goBack()}
              onMouseDown={e => e.preventDefault()} 
              style={{ 
                width: '40px', 
                height: '40px', 
                borderRadius: '50%', 
                backgroundColor: 'var(--btn-default-bg)', 
                border: '1px solid var(--btn-default-border)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                color: 'var(--text-color)', 
                cursor: 'pointer',
                outline: 'none',
                padding: 0
              }}
            >
              <i className="fa fa-arrow-left" />
            </button>
            <h2 style={{ margin: 0, fontSize: '28px', fontWeight: 'bold', color: 'var(--text-color)', display: 'flex', alignItems: 'center', gap: '12px' }}>
              <div style={{ width: '40px', height: '40px', borderRadius: '8px', backgroundColor: 'var(--panel-bg)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', fontSize: '18px', border: '1px solid var(--panel-border)' }}>
                <i className="fa fa-cog" />
              </div>
              {formatMessage(messages.PROPERTIES)}
            </h2>
          </div>

          {/* Main Card */}
          <div style={{ position: 'relative' }}>
            {/* Glow Aura */}
            <div style={{ position: 'absolute', top: '-10px', left: '-10px', right: '-10px', bottom: '-10px', background: 'linear-gradient(135deg, rgba(59, 130, 246, 0.2) 0%, rgba(147, 51, 234, 0.2) 100%)', filter: 'blur(24px)', zIndex: 0, borderRadius: '32px' }} />
            
            <div style={{ position: 'relative', zIndex: 1, backgroundColor: 'var(--panel-bg)', borderRadius: '24px', boxShadow: 'var(--glass-shadow)', border: '1px solid var(--panel-border)', overflow: 'hidden' }}>
              <div style={{ padding: '32px' }}>
                
                {/* Settings Form */}
                <div style={{ marginBottom: '32px' }}>
                  <div style={{ color: 'var(--text-muted)', fontSize: '14px', marginBottom: '24px' }}>{formatMessage(messages.PERSONAL_DATA)}</div>
                  <SettingsForm
                    onSubmit={onSubmit}
                    initialValues={{
                      name: user.name || '',
                      email: user.email || '',
                      phone: user.phone || '',
                    }}
                  />
                </div>

                {/* Security Section */}
                <div style={{ padding: '24px', backgroundColor: 'var(--bg-color)', borderRadius: '8px', border: '1px solid var(--panel-border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <div>
                    <div style={{ fontWeight: 'bold', fontSize: '16px', marginBottom: '4px', color: 'var(--text-color)' }}>{formatMessage(messages.SECURITY)}</div>
                    <div style={{ color: 'var(--text-muted)', fontSize: '13px' }}>{formatMessage(messages.SECURITY_DESC)}</div>
                  </div>
                  <Link
                    to="/settings/password/"
                    style={{ backgroundColor: 'var(--btn-default-bg)', color: 'var(--text-color)', padding: '10px 20px', borderRadius: '6px', fontWeight: 'bold', textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '8px', border: '1px solid var(--btn-default-border)', transition: 'background-color 0.2s' }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'var(--hover-bg)'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'var(--btn-default-bg)'}
                  >
                    <i className="fa fa-lock" />
                    {formatMessage(messages.CHANGE_PASSWORD)}
                  </Link>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default connect(null,
  dispatch => ({
    onSubmit: async formData => {
      const data = await updateSettings2({
          ...formData,
          email: formData.email || undefined,
          phone: formData.phone || undefined,
        }
      );
      if (data.response) {
        const user = data.response;
        dispatch(updated(user));
        dispatch(push('/'));
      } else {
        return { [FORM_ERROR]: data.error[Object.keys(data.error)[0]] };
      }
    },
  })
)(injectIntl(SettingsPage));
